// This function is a TypeScript-aware null checking function. It is especially useful
// as a parameter to Array.filter as TypeScript is able to infer that an Array<T | null | undefined>
// can be narrowed into an Array<T> when this function is used
export function isNonNull(value) {
    return value !== null && value !== undefined;
}
export function isTruthy(value) {
    return !!value;
}
export function hasIntersection(arr1, arr2) {
    if (!arr1 || !arr2)
        return false;
    return arr1.some((value) => arr2.includes(value));
}
export const isValidUuid = (value) => {
    return !!value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
};
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
//# sourceMappingURL=predicates.js.map